module.exports = __webpack_public_path__ + "static/media/canLeadToStroke.d82e847d.mp3";